import SourceFlowApplicationForm from "@sourceflow-uk/sourceflowapplicationform";
import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import cn from "classnames";
import { Helmet } from "react-helmet";

import classes from "./styles.module.scss";

export default function ({
  className,
  formId = null,
  jobId = null,
  custom_submission_page_url,
  submission_page_url = `${custom_submission_page_url ? custom_submission_page_url : "/submission-complete/"}`,
  onSubmitDone = () => {
    window.location.href = `${submission_page_url}`;
  },
}) {
  if (!formId && !jobId) return null;

  return (
    <div className={cn(className, classes.Form)}>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://cdn.jsdelivr.net/npm/choices.js/public/assets/styles/choices.min.css"
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.2/css/all.min.css"
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
      </Helmet>
      {jobId ? (
        <SourceFlowApplicationForm jobId={jobId} onSubmitDone={onSubmitDone} />
      ) : (
        <SourceFlowForm formId={formId} onSubmitDone={onSubmitDone} />
      )}
    </div>
  );
}
